import { Product } from '../../../typings/products';

export const UPDATE_INTERNAL_PRODUCT = 'UPDATE_INTERNAL_PRODUCT';
export type UPDATE_INTERNAL_PRODUCT = typeof UPDATE_INTERNAL_PRODUCT;

export interface UpdateInternalProduct {
    type: UPDATE_INTERNAL_PRODUCT;
    product: Product;
    isSaved?: boolean;
}

export function updateInternalProductAction(product: Product, isSaved?: boolean): UpdateInternalProduct {
    return {
        type: UPDATE_INTERNAL_PRODUCT,
        product,
        isSaved
    };
}
